/**
 * NetworkChannelLink entity class
 */

/**
 * NetworkChannelLinkFactory
 * returns NetworkChannelLink entity class
 *
 * @class NetworkChannelLinkFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkChannelLink} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkChannelLinkFactory
 */
/* @ngInject */
export default function NetworkChannelLinkFactory (Entity) {
  /* === NetworkChannelLink class === */

  /**
   * NetworkChannelLink model
   *
   * @class NetworkChannelLink
   * @classdesc NetworkChannelLink model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing NetworkChannelLink entity fields
   * @return {models.NetworkChannelLink} NetworkChannelLink entity
   */
  function NetworkChannelLink () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkChannelLink.prototype = Object.create(Entity.prototype)
  NetworkChannelLink.prototype.constructor = NetworkChannelLink

  /* === NetworkChannelLink instance methods & fields === */

  Object.assign(NetworkChannelLink.prototype, {

    /**
     * instance fields
     *
     * @memberof models.NetworkChannelLink#
     * @type {Object}
     */
    _fields: {
      id: Number,
      assigned: Boolean,
      channel: 'Channel',
      network: 'Network',
      sortOrder: Number
    }

  })

  /* === NetworkChannelLink static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(NetworkChannelLink, Entity)
  NetworkChannelLink._name = 'NetworkChannelLink'
  NetworkChannelLink.init()

  return NetworkChannelLink
}
